document.addEventListener("DOMContentLoaded", function () {
  const fieldList = document.querySelectorAll(".field");
  fieldList?.forEach((field) => {
    const searchInput = field.querySelector("input");
    const fieldLabel = field.querySelector(".field__label");
    if (searchInput?.value != "") {
      fieldLabel?.classList.add("hidden");
    } else {
      fieldLabel?.classList.remove("hidden");
    }
    searchInput?.addEventListener("input", (event) => {
      const value = event.target.value;
      if (value == "") {
        fieldLabel?.classList.remove("hidden");
      } else {
        fieldLabel?.classList.add("hidden");
      }
    });

    searchInput?.addEventListener("blur", (event) => {
      const value = event.target.value;
      if (value == "") {
        fieldLabel?.classList.remove("hidden");
      } else {
        fieldLabel?.classList.add("hidden");
      }
    });
  });

  // 图搜
  const searchIcon = document.querySelector("#imageUpload");
  searchIcon?.addEventListener("change", (event) => {
    const file = event.target.files[0];
    if (!file) return;
    uploadAndProcessImage(file);
  });

  function showMessage() {
    const message = document.querySelector("#failMsg"); //添加成功
    message?.classList.remove("hidden");
    var timer = setTimeout(() => {
      clearTimeout(timer);
      message?.classList.add("hidden");
    }, 2000);
  }

  function uploadAndProcessImage(file) {
    const loading = document.querySelector(
      ".picture-search-tips .loading-overlay"
    );
    new Compressor(file, {
      quality: 0.8,
      maxWidth: 1200,
      maxHeight: 1200,
      success(result) {
        const formData = new FormData();
        formData.append("file", result);
        // 上传压缩后的图片
        try {
          loading?.classList.remove("hidden");
          fetch(`${BASE_URL}api/v1/product/image/upload`, {
            method: "POST",
            body: formData,
          })
            .then((response) => response.json())
            .then((responseData) => {
              if (responseData.code == 200) {
                const image = responseData.data;
                location.href = `/pages/picture-search?imageUrl=${image}`;
              }
            })
            .finally(() => {
              loading?.classList.add("hidden");
            })
            .catch(() => {
              showMessage();
              console.error("上传出错:", error);
            });
        } catch (error) {
          loading?.classList.add("hidden");
          showMessage();
          console.error("上传出错:", error);
        }
      },
      error(err) {
        console.error("图片压缩失败:", err);
      },
    });
  }

  // 添加粘贴图片功能
  document.addEventListener("paste", async (event) => {
    const items = (event.clipboardData || event.originalEvent.clipboardData)
      .items;

    for (let i = 0; i < items.length; i++) {
      if (items[i].type.indexOf("image") !== -1) {
        const file = items[i].getAsFile();
        const objectUrl = URL.createObjectURL(file);
        document.querySelector("#findSimilarImg").src = objectUrl;
        document
          .querySelector("#findSimilarBtn")
          ?.addEventListener("click", () => {
            uploadAndProcessImage(file);
          });
        document.querySelector(".find-similar-pop")?.classList.remove("hidden");

        event.preventDefault(); // 阻止默认粘贴行为
        break;
      }
    }
  });

  // 点击其他区域关闭图搜
  document.addEventListener("click", (event) => {
    const findSimilarPop = document.querySelector(".find-similar-pop");
    if (findSimilarPop && !findSimilarPop.contains(event.target)) {
      findSimilarPop.classList.add("hidden");
    }
  });

  document
    .querySelector(".picture-search-icon")
    ?.addEventListener("mouseenter", () => {
      if (
        document
          .querySelector(".find-similar-pop")
          ?.classList.contains("hidden")
      ) {
        document
          .querySelector(".picture-search-tips")
          ?.classList.add("visible");
      }
    });
  document
    .querySelector(".picture-search-icon")
    ?.addEventListener("mouseleave", () => {
      document
        .querySelector(".picture-search-tips")
        ?.classList.remove("visible");
    });

  // 添加拖拽上传图片功能
  function handleDrop(event) {
    event.preventDefault();
    event.stopPropagation();

    if (event.dataTransfer.files && event.dataTransfer.files.length > 0) {
      const file = event.dataTransfer.files[0];
      if (!file) return;
      if (file.type.match("image.*")) {
        uploadAndProcessImage(file);
      }
    }
  }

  // 为整个搜索区域添加拖拽事件
  const searchArea = document.querySelector(".picture-search--content");
  if (searchArea) {
    searchArea.addEventListener("dragover", function (event) {
      event.preventDefault();
      event.stopPropagation();
      this.classList.add("drag-over");
    });

    searchArea.addEventListener("dragleave", function (event) {
      event.preventDefault();
      event.stopPropagation();
      this.classList.remove("drag-over");
    });

    searchArea.addEventListener("drop", handleDrop);
  }

  const headerBanderShow = sessionStorage.getItem("headerBanderShow") ?? true;
  const headerBander = document.querySelector("#header-bander");
  if (headerBanderShow === true) {
    headerBander?.classList.remove("hidden");
  } else {
    headerBander?.classList.add("hidden");
  }

  const banderClose = document.querySelector("#bander-close");
  banderClose?.addEventListener("click", () => {
    headerBander?.classList.add("hidden");
    sessionStorage.setItem("headerBanderShow", false);
  });

  let countdownData = theme.countdown("2024/12/03"); // 初始化
  renderCountdown(countdownData);
  const intervalId = setInterval(() => {
    countdownData = theme.countdown("2024/12/03");
    renderCountdown(countdownData);
    if (
      countdownData.seconds == 0 &&
      countdownData.hours == 0 &&
      countdownData.minutes == 0 &&
      countdownData.days == 0
    ) {
      clearInterval(intervalId);
    }
  }, 1000);

  function renderCountdown(countdown) {
    const days = Math.floor(countdown.days);
    const hours = Math.floor(countdown.hours);
    const minutes = Math.floor(countdown.minutes);
    const seconds = Math.floor(countdown.seconds);
    const countdownDays = document.querySelector(".countdown-days");
    const countdownHours = document.querySelector(".countdown-hours");
    const countdownMinutes = document.querySelector(".countdown-minutes");
    const countdownSeconds = document.querySelector(".countdown-seconds");
    countdownDays
      ? (countdownDays.textContent = days < 10 ? `0${days}` : days)
      : "";
    countdownHours
      ? (countdownHours.textContent = hours < 10 ? `0${hours}` : hours)
      : "";
    countdownMinutes
      ? (countdownMinutes.textContent = minutes < 10 ? `0${minutes}` : minutes)
      : "";
    countdownSeconds
      ? (countdownSeconds.textContent = seconds < 10 ? `0${seconds}` : seconds)
      : "";
  }
});
